import PropTypes from 'prop-types'

import { DynamScanner } from '@components/vin'
import { AdasBox, AdasFormControl, AdasModal, AdasPaper } from '@components/wrapper-components'
import classes from '../shared/VehicleInfo.module.css'

export const VinScannerModal = (props) => {
  const { open, onClose, vinSuccessHandler } = props

  return (
    <AdasPaper elevation={0} className='p-[20px]'>
      <AdasBox className={classes.vehicle}>
        <AdasFormControl fullWidth>
          {/* The scanner sizes itself to 100% of the modal's content box, which AdasModal leaves
              unsized since the shadcn migration (it used to be MUI's full-screen Modal) — so the
              camera view collapsed to nothing. Make the content box fill the viewport. */}
          <AdasModal
            key={'modal'}
            open={open}
            onClose={onClose}
            aria-labelledby='modal-modal-title'
            aria-describedby='modal-modal-description'
            className='h-[100dvh] w-screen !rounded-none bg-black shadow-none'
          >
            <>
              <DynamScanner setVinNumber={vinSuccessHandler} closeModalFunc={onClose} switchToManual={onClose}></DynamScanner>
            </>
          </AdasModal>
        </AdasFormControl>
      </AdasBox>
    </AdasPaper>
  )
}

VinScannerModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  vinSuccessHandler: PropTypes.func.isRequired
}
